<!--<small class="debug">{{me}}</small>-->
<div class="pull-left">
    @if (!printing) {
        <button mat-raised-button (click)="toggleMinimize.emit();">
            <mat-icon>format_list_bulleted</mat-icon>
        </button>
    }
</div>
<div class="pull-right">
    @if (!printing) {
        <button mat-raised-button (click)="printElem()">
            <mat-icon>print</mat-icon>
        </button>
    }
</div>
<br>
<br>
<div class="clearFloat">
</div>
<mat-divider></mat-divider>
@if (!m_order) {
    <div>
        <div fxLayout="row" fxLayoutAlign="center center">
            <div class="address">
                {{ 'general.noOrders' | transloco }}
            </div>
        </div>
    </div>
}
@if (m_order) {
    <div style="padding: 40px">
        <br/>
        <span class="orderNumber">
          <!--        <app-logo style="position: relative; top: -50px"></app-logo>-->
            @if (printing && m_paid && m_paid === '2') {
                <span style="position: fixed; right: 60px; font-size: 5em; font-family: Audiowide, Montserrat, sans-serif !important; opacity: 0.3; color: gray ; transform: rotate(45deg)">PAID</span>
            }
        </span>
        <div class="row" id="printableArea">
            <div>
                <div>
                    <img src="data:image/png;base64,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"
                         alt="DigitalSignage.com"/>
                </div>
                <div class="invoice-title">
                    <span style="font-size: 20px !important;">MediaSignage Inc.</span><br/>
                    <span style="font-size: 10px !important;">5776-D Lindero Cyn Rd #182 Westlake Village, CA 91362 USA</span><br/>
                    <span style="font-size: 10px !important;">1.877.DIG.SIGN 📞</span>
                </div>
                <br/>
                <h1 style="font-size: 2em">Invoice</h1>
                <br/>
                <br/>
                <div>
                    @if (m_status === 'QUOTE') {
                        <mat-label style="font-size: 14px !important;">quote: {{ m_orderId }}</mat-label>
                    } @else {
                        <mat-label style="font-size: 14px !important;">order: {{ m_orderId }}</mat-label><br/>
                    }<br/>
                    <mat-label style="font-size: 14px !important;">{{ 'general.placedOn' | transloco }} {{ getDate() }}</mat-label>
                </div>
                <br/>
            </div>
            <mat-divider></mat-divider>
            <br/>
            <br/>
            <div class="row">
                <div class="pull-left">
                    <div class="address" style="font-size: 14px !important;">
                        <strong>{{ 'general.billedTo' | transloco }}: </strong><br>
                        <span class="whiteReplace">
                    {{ getBilling() }}
                  </span>
                    </div>
                </div>
                <br/>
                <div class="pull-right">
                    <div class="address" style="font-size: 14px !important;">
                        <strong>{{ 'general.shippedTo' | transloco }}: </strong><br>
                        <span class="whiteReplace">
                    {{ getShipping() }}
                  </span>
                    </div>
                </div>
            </div>
            <div class="row clearFloat">
                <div>
                    <div class="address">
                        <br/>
                        <strong>{{ m_order?.billing?.email }}</strong>
                        <br/>
                    </div>
                    @if (showProgress) {
                        <div>
                            <strong>{{ 'general.tracking' | transloco }}:</strong><br>
                            {{ getTracking() }}
                            <br/>
                            <br/>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="row">
            <hr/>
            <h3><strong>{{ 'general.orderSummary' | transloco }}</strong></h3>
            <div>
                <simpleGridTable #userSimpleGridTable>
                    <thead>
                    <tr>
                        <th>{{ 'general.product' | transloco }}</th>
                        <th>{{ 'general.quantity' | transloco }}</th>
                        <th>{{ 'general.price' | transloco }}</th>
                        <th>{{ 'general.total' | transloco }}</th>
                        <th>{{ 'general.notes' | transloco }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        @for (item of products; track item; let index = $index) {
                            <tr class="simpleGridRecord">
                                <td [item]="item" style="width: 40%" [editable]="false" [processField]="tableDesc" simpleGridData></td>
                                <td [item]="item" style="width: 10%" [editable]="false" [processField]="tableQty" simpleGridData></td>
                                <td [item]="item" style="width: 10%" [processField]="tablePrice(item)" simpleGridData></td>
                                <td [item]="item" style="width: 10%" [processField]="tableTotal(item)" simpleGridData></td>
                                <td [item]="item" style="width: 30%" [processField]="tableNotes(item)" simpleGridData></td>
                            </tr>
                        }
                    </tbody>
                </simpleGridTable>
                @if (subsInvoice) {
                    <div>
                        <br/>
                        <br/>
                        <mat-divider></mat-divider>
                        <br/>
                        <hr/>
                        <table>
                            <tbody>
                            <tr>
                                <td class="thick-line text-left"><b>{{ 'general.discount' | transloco }}</b></td>
                                <td class="thick-line"></td>
                                <td class="thick-line"></td>
                                <td class="thick-line text-right">{{ getDiscount() }}</td>
                            </tr>
                            <tr>
                                <td class="no-line text-left"><b>{{ 'general.subtotal' | transloco }}</b></td>
                                <td class="no-line"></td>
                                <td class="no-line"></td>
                                <td class="no-line text-right">{{ getSubtotal() }}</td>
                            </tr>
                            <tr>
                                <td class="no-line text-left"><b>{{ 'general.tax' | transloco }}</b></td>
                                <td class="no-line"></td>
                                <td class="no-line"></td>
                                <td class="no-line text-right">{{ getTax() }}</td>
                            </tr>
                            <tr>
                                <td class="no-line text-left"><b>{{ 'general.shipping' | transloco }}</b></td>
                                <td class="no-line"></td>
                                <td class="no-line"></td>
                                <td class="no-line text-right">{{ getShippingTotal() }}</td>
                            </tr>
                            <tr>
                                <td class="no-line text-left"><b>{{ 'general.total' | transloco }}</b></td>
                                <td class="no-line"></td>
                                <td class="no-line"></td>
                                <td class="no-line text-right">{{ getTotal() }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </div>
    </div>
}




